/**
 * Collapsed Form CTA Component
 * @module patterns/components/collapsed-form-cta
 */

import { isMobile } from '@root/src/framework/scripts/helpers/browser/media-query';
import { type App } from '~/app';

import { getMainEnquiryForm } from '../form-and-content/modal-form/modal-form';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Collapsed CTA Component');

    const listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]> = [];

    app.afterMount
        .then(() => {
            mountCollapsedFormCta(listeners);
        })
        .catch((error) => {
            throw new Error('[Stockland FE] Unable to register Stockland Collapsed Form CTA component', error);
        });

    return function destroyCollapsedFormCta() {
        unMountCollapsedFormCta(listeners);

        app.logger.debug('[DXA] Collapsed Form CTA component destroyed');
    };
};

function mountCollapsedFormCta(
    listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>
) {
    const collapsedFormCta = document.querySelector('.collapsed-form-cta');

    if (collapsedFormCta) {
        const ctaHeadings = collapsedFormCta.querySelector<HTMLElement>('.collapsed-cta-headings');
        const ctaButton = collapsedFormCta.querySelector<HTMLElement>('.collapsed-cta-button');
        const form = collapsedFormCta.querySelector<HTMLElement>('.collapsed-form');
        const overlayGradient = collapsedFormCta.querySelector<HTMLElement>('.overlay-gradient');
        const imageContainer = collapsedFormCta.querySelector<HTMLElement>('.collapsed-form-container');
        const formContainer = collapsedFormCta.querySelector<HTMLElement>('.form-container');

        const showForm = () => {
            ctaHeadings?.classList.add('active');
            ctaButton?.classList.add('active');
            form?.classList.remove('hidden');
            overlayGradient?.classList.add('active');
            imageContainer?.classList.add('md:h-[810px]');
            formContainer?.classList.add('md:absolute', 'md:component-spacing-top-xl');

            if (isMobile()) {
                form?.scrollIntoView({ behavior: 'smooth' });
            }
        };
		
        if (ctaButton) {
            if (form) {
                ctaButton.addEventListener('click', showForm);
                listeners.push([ctaButton, 'click', showForm]);
            } else {
                const modalButton = getMainEnquiryForm();
                if (modalButton) {
                    ctaButton.addEventListener('click', ()=>{modalButton.click()});
                    listeners.push([ctaButton, 'click',  ()=>{modalButton.click()}]);
                }
            }
        }
    }
}

function unMountCollapsedFormCta(
    listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>
) {
    for (const [element, event, listener] of listeners) {
        element.removeEventListener(event, listener);
    }
}
